import { Box, Grid, Typography, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Container, useTheme, IconButton, InputAdornment, CircularProgress, Autocomplete, Checkbox, Chip, ListItemText } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import { useTaskContext } from "../../../shared/context/taskContext";
import { useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { useUtiles } from "../../../shared/context/utilesContext";
import moment from "moment";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import SelectAssignedOTComponent from "../components/SelectAssignedOTComponent";
import { PatternFormat } from "react-number-format";
import { Controller, useForm } from "react-hook-form";
import { useRrhh } from "../../../shared/context/rrhhContext";

export default function OTcreateView() {
    const { OtWithTaskPending, resetOtWithTaskPending, setSelectedTaskPending, selectedTaskPending, setOtWithTaskPending, loadingCreateOTWithTasks, createOTWithTasks } = useTaskContext()

    const { rrhh, getRrhh } = useRrhh()

    const { toogleOpenSilder, priorityOptions, sumaTimeDurationTask, getFirstNameAndLastName } = useUtiles()

    const theme = useTheme()

    const navigate = useNavigate()

    const { control, setValue, handleSubmit, formState: { errors } } = useForm()

    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');



    const handleValueChange = (values, name) => {
        const input = values.value; // solo números, ej: "12345"
        const formatted = values.formattedValue; // ej: "123:45"
        setValue(formatted);

        const parts = formatted.split(':');
        if (parts.length === 2) {
            const minutes = parseInt(parts[1], 10);
            if (isNaN(minutes) || minutes < 0 || minutes > 59) {
                setError(true);
                setHelperText('Los minutos deben estar entre 00 y 59');
            } else {
                setError(false);
                setHelperText('');
            }
        } else {
            setError(true);
            setHelperText('Debe tener el formato HHH:MM');
        }

        setOtWithTaskPending({ ...OtWithTaskPending, [name]: formatted })
    };



    const handleToBack = async () => {
        // Solo mostrar el diálogo de confirmación si hay tareas pendientes
        if (OtWithTaskPending.task_list.length > 0) {
            const result = await Swal.fire({
                title: '¿Estás seguro de querer salir?',
                text: 'Se perderán las tareas seleccionadas',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, salir',
                cancelButtonText: 'Cancelar'
            });

            // Si el usuario cancela, detener la navegación
            if (!result.isConfirmed) {
                return;
            }
        }

        // En cualquier caso, resetear y navegar hacia atrás
        setSelectedTaskPending([])
        resetOtWithTaskPending();
        navigate('/task/wo');

    }


    const handleDeleteTaskPending = async (task) => {
        const result = await Swal.fire({
            title: '¿Estás seguro de querer eliminar la tarea?',
            text: 'Se perderá la tarea seleccionada',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) {
            return;
        }
        const activityKey = task.task_scheduled_id ? `s-${task.task_scheduled_id}` : `t-${task.id}`
        const isSameActivity = (item) => (item.task_scheduled_id ? `s-${item.task_scheduled_id}` : `t-${item.id}`) === activityKey
        setSelectedTaskPending(selectedTaskPending.filter(item => !isSameActivity(item)))
        setOtWithTaskPending(prev => ({ ...prev, task_list: prev.task_list.filter(item => !isSameActivity(item)) }))
    }



    useEffect(() => {
        setValue('time_execution', sumaTimeDurationTask(OtWithTaskPending.task_list))
        setOtWithTaskPending(prev => ({ ...prev, time_execution: sumaTimeDurationTask(OtWithTaskPending.task_list) }))
    }, [OtWithTaskPending.task_list])


    //OBTENER LA FECHA MAS ACTUAL DE LAS TAREAS
    const getDatetimeCreated = () => {
        if(OtWithTaskPending.task_list.length === 0) return ""
        const datetimeCreated = OtWithTaskPending.task_list.reduce((max, task) => {
            return new Date(task.datetime_start_estimated) > new Date(max) ? task.datetime_start_estimated : max
        }, new Date(OtWithTaskPending.task_list[0].datetime_start_estimated))
        //devolver en formato YYYY-MM-DD HH:MM:SS usando moment
        return moment(datetimeCreated).format('YYYY-MM-DD HH:mm:ss')
    }

    useEffect(() => {
        setOtWithTaskPending(prev => ({ ...prev, datetime_created: getDatetimeCreated() }))
    }, [OtWithTaskPending.task_list])



    return (
        <>
            <Container maxWidth="xl" sx={{
                padding: '0px', margin: '0px',
            }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <IconButton
                        onClick={handleToBack}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <Button 
                        disabled={!OtWithTaskPending.assigned_to || OtWithTaskPending.task_list.length === 0 || error} 
                        variant="contained" 
                        color="primary" 
                        startIcon={<SaveIcon />} 
                        onClick={createOTWithTasks}
                    >
                        {loadingCreateOTWithTasks ? <CircularProgress size={20} /> : 'Guardar'}
                    </Button>
                </Box>
                <Box sx={{ p: 2, borderRadius: '10px', backgroundColor: theme.palette.background.paper, boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' }}>
                    <Grid container spacing={2}>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Asignar responsable de OT:</Typography>
                            <Controller
                                control={control}
                                name="assigned_to"
                                render={({ field }) => (

                                    <TextField
                                        onClick={() => toogleOpenSilder(<SelectAssignedOTComponent />, 500, 'Asignar responsable de OT')}
                                        value={OtWithTaskPending.assigned_to?.fullName}
                                        variant="outlined"
                                        fullWidth
                                        error={!OtWithTaskPending.assigned_to}
                                        helperText={!OtWithTaskPending.assigned_to ? 'Debe seleccionar un responsable' : ''}
                                        onChange={(e) => {
                                            field.onChange(e)
                                            setValue('assigned_to', e.target.value)
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                                startAdornment: OtWithTaskPending.assigned_to && (
                                                    <InputAdornment position="start">
                                                        <Box sx={{
                                                            mr: 1,
                                                            width: 30,
                                                            height: 30,
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            bgcolor: 'primary.light',
                                                            color: 'white',
                                                            overflow: 'hidden'
                                                        }}>
                                                            {OtWithTaskPending.assigned_to.avatar ? (
                                                                <img
                                                                    src={OtWithTaskPending.assigned_to.avatar}
                                                                    alt={OtWithTaskPending.assigned_to.fullName}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                />
                                                            ) : (
                                                                <Box sx={{ fontSize: 14 }}>
                                                                    {OtWithTaskPending.assigned_to.fullName.charAt(0).toUpperCase()}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </InputAdornment>
                                                )
                                            }
                                        }}
                                    />
                                )}
                            /> 
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Apoyo técnico extra (Opcional):</Typography>
                            <Autocomplete
                                options={rrhh}
                                renderInput={(params) => <TextField {...params} />}
                                multiple
                                freeSolo

                                onInputChange={(e, value) => {
                                    getRrhh({
                                        exclude: OtWithTaskPending.assigned_to?.num_document,
                                        fullName: value,
                                        user_task_attender: true
                                    })
                                }}
                                value={ Array.isArray(OtWithTaskPending.extra_technical_support) ? OtWithTaskPending.extra_technical_support : []}
                                onChange={(e, newValue) => {
                                    // Filtrar valores duplicados basados en el id
                                    const uniqueValues = newValue.filter((item, index, self) =>
                                        index === self.findIndex((t) => t.id === item.id)
                                    );
                                    setOtWithTaskPending(prev => ({ ...prev, extra_technical_support: uniqueValues }))
                                }}
                                getOptionLabel={(option) => option.fullName}
                                renderOption={(props, option) => {
                                    const { key, ...otherProps } = props;
                                    return (
                                        <li key={key} {...otherProps}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1
                                            }}>
                                                <Checkbox 
                                                    checked={OtWithTaskPending.extra_technical_support.some(
                                                        tech => tech.id === option.id
                                                    )} 
                                                />
                                                <Box sx={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    bgcolor: 'primary.light',
                                                    color: 'white',
                                                    overflow: 'hidden',
                                                    mr: 1
                                                }}>
                                                    {option.avatar ? (
                                                        <img
                                                            src={option.avatar}
                                                            alt={option.fullName}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    ) : (
                                                        <Box sx={{ fontSize: 14 }}>
                                                            {option.fullName.charAt(0).toUpperCase()}
                                                        </Box>
                                                    )}
                                                </Box>
                                                <ListItemText primary={option.fullName} />
                                            </Box>
                                        </li>
                                    );
                                }}
                                onOpen={() => getRrhh({ exclude: OtWithTaskPending.assigned_to?.num_document, user_task_attender: true })}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            label={`${getFirstNameAndLastName(option.fullName)}`}
                                            {...getTagProps({ index })}
                                            avatar={
                                                <Box
                                                    sx={{
                                                        width: 24,
                                                        height: 24,
                                                        bgcolor: theme.palette.primary.main,
                                                        color: '#ffffff !important',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    { option.fullName.charAt(0).toUpperCase()}
                                                </Box>
                                            }
                                        />
                                    ))
                                }
                            />
                        </Grid>

                        <Grid item size={{ xs: 12 }}>
                            <TableContainer sx={{ maxHeight: 440, minHeight: "440px", width: '100%' }}>
                                <Table size="small" stickyHeader aria-label="sticky table" sx={{ width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ minWidth: '60px' }}></TableCell>
                                            <TableCell sx={{ minWidth: '60px' }}>Activo</TableCell>
                                            <TableCell sx={{ minWidth: '200px' }}>Tarea</TableCell>
                                            <TableCell sx={{ minWidth: '100px' }}>Tipo de tarea</TableCell>
                                            <TableCell sx={{ minWidth: '100px' }}>F. programada</TableCell>
                                            <TableCell sx={{ minWidth: '60px' }}>Prioridad</TableCell>
                                            <TableCell sx={{ minWidth: '60px' }}>Clasificación 1</TableCell>
                                            <TableCell sx={{ minWidth: '60px' }}>Clasificación 2</TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {OtWithTaskPending.task_list.map((task, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <IconButton onClick={() => handleDeleteTaskPending(task)}>
                                                        <DeleteOutlineRoundedIcon />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell>
                                                    {task.assets[0]?.name}
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        task.description
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {task.type_task?.value}
                                                </TableCell>
                                                <TableCell>
                                                    {moment(task.datetime_start_estimated).format('DD/MM/YYYY')}
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        {priorityOptions.find(option => option.value === task.priority)?.icon}
                                                        <Typography variant="body2">
                                                            {task.priority}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    {task.classification_1?.value}
                                                </TableCell>
                                                <TableCell>
                                                    {task.classification_2?.value}
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                    </Grid>
                </Box>

            </Container>
        </>
    );
}